type Item = { id: number; [key: string]: any };
export function arrayToObject<T extends Item>(items: T[]) {
  let object: { [key: number]: T } = {};
  items.forEach((item) => (object[item.id] = item));

  return object;
}
